<div class="modal-header">
  <h4 class="modal-title">Export Event Waitlist</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="form-group">
    <label for="downloadFileNameInput">Download File Name</label>
    <input type="text" class="form-control" id="downloadFileNameInput" name="downloadFileName"
           [(ngModel)]="downloadFileName">
  </div>

  <div class="form-group">
    <label>Columns:</label>
    <button class="btn btn-link btn-sm p-0 float-right"
            *ngIf="!allColumnsAreSelected()"
            (click)="setAllColumnsSelected(true)">
      Select All
    </button>
    <button class="btn btn-link btn-sm p-0 float-right"
            *ngIf="allColumnsAreSelected()"
            (click)="setAllColumnsSelected(false)">
      Deselect All
    </button>
    <div class="form-check" *ngFor="let columnName of columnNames; let colIdx = index;">
      <input class="form-check-input" type="checkbox" [id]="'col' + colIdx + 'checkbox'"
             [(ngModel)]="selectedColumns[columnName]">
      <label class="form-check-label" [for]="'col' + colIdx + 'checkbox'">
        {{ columnName }}
      </label>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          [disabled]="noColumnsAreSelected()"
          [class.disabled]="noColumnsAreSelected()"
          (click)="handleSubmit()">
    Export
  </button>
</div>
